import Contact from './Contact';

document.addEventListener('DOMContentLoaded', () => {
  const pardotForm = document.getElementById('pardot-form');
  if (pardotForm) {
    const contact = new Contact(pardotForm);
    contact.mount();
  }
});
